// F6 — Channel Manager catalog is strictly Channex-supported OTAs.
// Previously we rendered 150+ cosmetic names (TravelBird, Weekendesk, …)
// that would never resolve against our Channex account. The old list
// made the UI look impressive but caused "ID not found" dead-ends for
// every host who clicked past Booking/Airbnb. Now the catalog mirrors
// what Channex actually distributes to, so every tile is a real path.
// Source: https://channex.io/channels (reviewed Feb 2026).

export const POPULAR_OTAS = [
  "Booking.com",
  "Airbnb",
  "Expedia",
  "Agoda",
  "MakeMyTrip",
  "Vrbo",
  "Hostelworld",
  "Google Hotel Ads",
];

export const OTA_CATALOG = [
  "Booking.com",
  "Airbnb",
  "Expedia",
  "Agoda",
  "MakeMyTrip",
  "Goibibo",
  "Vrbo",
  "Hostelworld",
  "Hotels.com",
  "Trip.com",
  "Traveloka",
  "Tiket.com",
  "Despegar",
  "Rakuten Travel",
  "Jalan",
  "HRS",
  "Mr & Mrs Smith",
  "Hotelbeds",
  "Pricetravel",
  "Google Hotel Ads",
];
